import { render, staticRenderFns } from "./WabaSupsisTemplateCategoryUpdate.vue?vue&type=template&id=a039dcbe&scoped=true"
import script from "./WabaSupsisTemplateCategoryUpdate.vue?vue&type=script&lang=js"
export * from "./WabaSupsisTemplateCategoryUpdate.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisTemplateCategoryUpdate.vue?vue&type=style&index=0&id=a039dcbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a039dcbe",
  null
  
)

export default component.exports